import { render } from "./ProfessionalSummary.vue?vue&type=template&id=1875c4b9&scoped=true"
import script from "./ProfessionalSummary.vue?vue&type=script&lang=js"
export * from "./ProfessionalSummary.vue?vue&type=script&lang=js"

import "./ProfessionalSummary.vue?vue&type=style&index=0&id=1875c4b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1875c4b9"]])

export default __exports__